import type { CardId } from "../types/index.js";

// 持ち込み候補と解放に必要なユニーククリアステージ数。Issue #4 論点3。
const BRING_IN_UNLOCKS = [
  { cardId: "idle", unlockAt: 0 },
  { cardId: "intern", unlockAt: 3 },
  { cardId: "hedge", unlockAt: 8 },
  { cardId: "field-judgment", unlockAt: 10 },
  { cardId: "paid-leave", unlockAt: 16 },
] as const satisfies readonly { cardId: CardId; unlockAt: number }[];

export const BRING_IN_CARD_IDS: readonly CardId[] = BRING_IN_UNLOCKS.map((entry) => entry.cardId);

export function countClearedStages(progress: readonly { cleared: boolean }[]): number {
  return progress.filter((stage) => stage.cleared).length;
}

export function isBringInUnlocked(cardId: CardId, clearedCount: number): boolean {
  const entry = BRING_IN_UNLOCKS.find((e) => e.cardId === cardId);
  return entry !== undefined && clearedCount >= entry.unlockAt;
}

export function unlockedBringInCards(clearedCount: number): CardId[] {
  return BRING_IN_UNLOCKS.filter((e) => clearedCount >= e.unlockAt).map((e) => e.cardId);
}

/** まだ解放されていない中で、いちばん近い持ち込み報酬。 */
export function nextBringInReward(clearedCount: number): { cardId: CardId; unlockAt: number } | null {
  return BRING_IN_UNLOCKS.find((entry) => entry.unlockAt > clearedCount) ?? null;
}

/** ロック表示用。候補外のカードは null。 */
export function bringInUnlockAt(cardId: CardId): number | null {
  return BRING_IN_UNLOCKS.find((e) => e.cardId === cardId)?.unlockAt ?? null;
}
